import { Component, Input, OnInit } from '@angular/core';
import { PaymentCollectionResponseByProfileIdForTable } from '../../model/payment/PaymentCollectionRequest';

@Component({
  selector: 'app-material-table',
  templateUrl: './material-table.component.html',
  styleUrls: ['./material-table.component.css']
})
export class MaterialTableComponent implements OnInit {

  @Input() dataSource: PaymentCollectionResponseByProfileIdForTable[];
  @Input() tableHeader: Array<any>;
  @Input() displayedColumns: string[];

  constructor() {
   }

  ngOnInit(): void {
  }

}
